// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_e01b10a"};